import config from 'utils/apiconfig';
import request from 'utils/request';

const {api} = config;
const {loginlog} = api;

/**
 * 查询列表
 */
export async function list(params) {
  return request({url: loginlog, method: 'get', data: params,});
}
